// /* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Heading } from 'grommet';
import { Box, PageContentBox, CheckBox, Text, List } from '../../components/element';
import { PageTitleBox } from '../../components/menu';
import { ShowContent } from '../../components/showContent';
import Strings from '../../locales/Strings';

import { preInstallationSelectedState } from '../../recoil/atoms';
import { getChecklistAction, setChecklistDone, toggleSideMenu } from '../../actions';
import { PageNavBar } from '../../components/page';
import { getQueryStringValues, validateSelectors } from '../../utils/withPath';
import { eventTracking } from '../../utils/eventTracker';
import { getDownloadInstallationGuideUrl, getPageContentReducerKey } from '../../utils/utils';
import { setLocalStorageChecklist } from '../../utils/localStorageUtils';
import {
  GA_ACTION_CHECKED,
  GA_ACTION_UNCHECKED,
  ALLETRAMP_OPT_BLUETOOTH,
  PAGENAME_PREINSTALLATION_BLUETOOTH,
  HPE_SIMPLIVITY,
  PAGENAME_PREINSTALLATION_SIMPLIVITY325,
  PAGENAME_PREINSTALLATION_SIMPLIVITY380,
  PAGENAME_PREINSTALLATION_SIMPLIVITY380PLUS,
  SIMPLIVITY_OPT_325GEN,
  SIMPLIVITY_OPT_325GEN_PLUSV2,
  SIMPLIVITY_OPT_380GEN,
  SIMPLIVITY_OPT_380GEN_PLUS,
  PAGENAME_PREINSTALLATION,
  EXISTING_ESXI_CLUSTER,
  PAGENAME_PREINSTALLATION_EXISTING,
  PAGENAME_PREINSTALLATION_NEW,
  PAGENAME_VALIDATE_ARRAY,
  NEW_ESXI_CLUSTER,
  PAGENAME_PREINSTALLATION_SIMPLIVITY325_GEN11,
  SIMPLIVITY_OPT_325GEN11,
  SIMPLIVITY_OPT_380GEN11,
  PAGENAME_PREINSTALLATION_SIMPLIVITY380_GEN11,
  MODEL_LIST_PCBE,
  PRODUCT_ID_ALLETRAB10K,
} from '../../constants';

export default function TechDocChecklistPage(props) {
  const history = props.history;
  const location = props.location;
  const [selected, setSelected] = useRecoilState(preInstallationSelectedState);

  const dispatch = useDispatch();
  const queryStringValues = getQueryStringValues(props.location);
  const productName = queryStringValues['product'];
  const [arrayModel] = useState(queryStringValues.model);
  // const [selected, setSelected] = React.useState(0);
  const [pageProps] = useState(props.pageProps);
  const [downloadFullDocUrl, setDownloadFullDocUrl] = useState('');
  const [downloadFullDocLabel, setDownloadFullDocLabel] = useState('');
  const [productId, setProductId] = useState(productName);

  const pageOpt = queryStringValues['opt'];
  let pageName = pageProps.pageName;
  const connectOpt = queryStringValues['connectopt'];
  const simplivitymodel = queryStringValues['simplivitymodel'];
  const hpeAlletraDHCImodel = queryStringValues['hpeAlletraDHCImodel'];

  if (productName === PRODUCT_ID_ALLETRAB10K && connectOpt === ALLETRAMP_OPT_BLUETOOTH) {
    pageName = PAGENAME_PREINSTALLATION_BLUETOOTH;
  }
  if (MODEL_LIST_PCBE.includes(arrayModel)) {
    switch (pageName) {
      case PAGENAME_PREINSTALLATION:
        pageName =
          hpeAlletraDHCImodel === EXISTING_ESXI_CLUSTER
            ? PAGENAME_PREINSTALLATION_EXISTING
            : PAGENAME_PREINSTALLATION_NEW;
        break;
      case PAGENAME_VALIDATE_ARRAY:
        pageName =
          hpeAlletraDHCImodel === NEW_ESXI_CLUSTER || hpeAlletraDHCImodel === EXISTING_ESXI_CLUSTER
            ? PAGENAME_VALIDATE_ARRAY
            : null;
        break;
      default:
        break;
    }
  }
  if (arrayModel === HPE_SIMPLIVITY) {
    switch (simplivitymodel) {
      case SIMPLIVITY_OPT_325GEN:
      case SIMPLIVITY_OPT_325GEN_PLUSV2:
        pageName = PAGENAME_PREINSTALLATION_SIMPLIVITY325;
        break;
      case SIMPLIVITY_OPT_380GEN:
        pageName = PAGENAME_PREINSTALLATION_SIMPLIVITY380;
        break;
      case SIMPLIVITY_OPT_380GEN_PLUS:
        pageName = PAGENAME_PREINSTALLATION_SIMPLIVITY380PLUS;
        break;
      case SIMPLIVITY_OPT_325GEN11:
        pageName = PAGENAME_PREINSTALLATION_SIMPLIVITY325_GEN11;
        break;
      case SIMPLIVITY_OPT_380GEN11:
        pageName = PAGENAME_PREINSTALLATION_SIMPLIVITY380_GEN11;
        break;
      default:
        break;
    }
  }
  const modelList = useSelector(props => props.techDocReducer['modelList']);
  const reducerKey = getPageContentReducerKey({ pageName, model: arrayModel });
  let content = useSelector(props => props.techDocReducer[reducerKey]);

  useEffect(() => {
    if (modelList && Object.keys(modelList).length > 0 && validateSelectors({ location, history, modelList })) {
      const modelDocConfig = modelList[arrayModel];
      setProductId(modelDocConfig.productId);
      const downloadDocObj = getDownloadInstallationGuideUrl({
        productName: modelDocConfig.productId,
        pageOpt,
        simplivitymodel,
        hpeAlletraDHCImodel,
        arrayModel,
      });
      setDownloadFullDocUrl(downloadDocObj.downloadFullDocUrl);
      setDownloadFullDocLabel(downloadDocObj.downloadFullDocLabel);
    }
    setSelected(0);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (modelList && Object.keys(modelList).length > 0 && validateSelectors({ location, history, modelList })) {
      const modelDocConfig = modelList[arrayModel];
      getChecklistAction({
        arrayModel,
        modelDocConfig,
        pageName,
        productName,
        pageOpt,
        connectOpt,
        simplivitymodel,
        hpeAlletraDHCImodel,
        dispatch,
      });
    }
  }, [
    modelList,
    arrayModel,
    history,
    location,
    pageName,
    productName,
    connectOpt,
    pageOpt,
    simplivitymodel,
    hpeAlletraDHCImodel,
    dispatch,
  ]);

  const pageCategory = '' || pageProps.category;

  let checklistItems = content && content.checklist ? content.checklist : [];

  function onClickItem(event) {
    setSelected(event.index);
  }
  function handleCheckboxChange(evt, chItem) {
    let checklist = checklistItems;
    for (let el of checklist) {
      if (el.id === chItem.id) {
        el.done = !chItem.done;
      }
    }
    setLocalStorageChecklist({
      productName: productId,
      pageName,
      arrayModel,
      pageOpt: pageOpt,
      connectOpt: connectOpt,
      simplivitymodel,
      hpeAlletraDHCImodel,
      checklist,
    });

    setChecklistDone({
      checklist,
      arrayModel,
      pageName,
      pageOpt: pageOpt,
      connectOpt,
      simplivitymodel,
      hpeAlletraDHCImodel,
      productName: productId,
      dispatch,
    });
    const action = chItem.done ? GA_ACTION_CHECKED : GA_ACTION_UNCHECKED;
    eventTracking({ evt, location, action });
  }

  return (
    <PageContentBox fill={true}>
      <PageTitleBox
        responsive={props.responsive}
        title={Strings[pageName]}
        category={Strings[pageCategory]}
        onResponsiveMenuIconClick={() => toggleSideMenu(true, dispatch)}
        downloadUrl={downloadFullDocUrl}
        downloadTitle={downloadFullDocLabel}
      />
      <Box>
        <Grid
          areas={[
            { name: 'main', start: [0, 0], end: [0, 0] },
            { name: 'side', start: [1, 0], end: [1, 0] },
          ]}
          columns={['flex', '220px']} //medium
          rows={['full']}
          gap="small">
          <Box gridArea="main" pad="small" round="xsmall" border="all" className="markdownContent">
            <Heading level={3} margin={{ top: '5px' }}>
              {checklistItems[selected]?.title || ''}
            </Heading>
            <ShowContent contentString={checklistItems[selected]?.content || ''} />
          </Box>
          <List
            gridArea="side"
            data={checklistItems}
            border={false}
            pad="xsmall"
            itemProps={
              // TODO
              selected >= 0 ? { [selected]: { background: '#F4F6F9', style: { fontWeight: '600' } } } : undefined
            }
            onClickItem={onClickItem}>
            {datum => (
              <Box direction="row" className="row">
                <CheckBox
                  className="checkbox"
                  direction="column"
                  data-test-id={`checklist-box#${datum.id}`}
                  data-title={datum.title}
                  checked={datum.done}
                  onChange={event => {
                    handleCheckboxChange(event, datum);
                  }}
                  label=""
                />
                <Text className="chk-label">{datum.title}</Text>
              </Box>
            )}
          </List>
        </Grid>
      </Box>
      <PageNavBar
        hide={checklistItems.length === 0}
        border="none"
        prevPage={pageProps.prevPage}
        nextPage={pageProps.nextPage}
        history={props.history}
        pageName={pageName}
      />
    </PageContentBox>
  );
}
